module.exports = __webpack_public_path__ + "static/media/6-_DSC7708.747502df.jpg";